module.exports = __webpack_public_path__ + "static/img/RAPS1000_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RAPS1000_1.png
// module id = Nmqs
// module chunks = 0